export interface JWTTokenPayload {
  sub: string; // consumerId
  exp: number;
  iss: string; // PREREG_JWT_ISSUER
  personId: string;
  dfdEventId: string;
  scope: {
    clinicalEvents?: {
      clinicalEventId: string;
    };
  };
}

export enum DFDHeaders {
  apiKey = 'apikey',
  apiKeyLocalhost = 'x-api-key',
  auditData = 'x-audit-data',
  authorization = 'authorization',
  cacheControl = 'cache-control',
  clinicalEventId = 'x-clinical-event-id',
  contentId = 'mhp-filter-content-id',
  dfdEventId = 'x-dfd-event-id',
  fhirAuthToken = 'x-fhir-auth-token',
  mobileDeviceId = 'x-device-id',
  patientId = 'x-patient-id',
  consumerId = 'x-dfd-consumer-id',
  requestId = 'x-request-id',
  webClientId = 'x-forwarded-for',
  productionApiKey = 'apikey',
  encounterId = 'x-encounter-id',
  mhpCacheControl = 'mhp-cache-control',
  contentType = 'content-type',
  date = 'mhp-filter-date',
  eventIds = 'mhp-filter-event-ids',
  filterSource = 'mhp-filter-source', // MILLENNIUM or CDR
  inquiringPatientId = 'x-user-patient-id', // This is for hipaa calls when the inquiring patient differs from the subject (or target) patient.
  kongApiKey = 'apikey',
  mhpAccept = 'accept',
  mhpAdapter = 'mhp-adapter',
  mhpAttachmentFileName = 'mhp-attachment-filename',
  mhpAuthGuardResponse = 'mhp-auth-guard-response', // This is for internal calls only
  mhpFilterContentId = 'mhp-filter-content-id',
  mhpFilterEncounterId = 'mhp-filter-encounter-id',
  mhpMessageUuid = 'mhp-message-uuid',
  mhpNVIdxPid = 'mhp-nv-idx-pid',
  mhpProviderId = 'mhp-provider-id',
  mhpTWmrn = 'mhp-tw-mrn',
  mhpUmpiLinkId = 'mhp-umpi-link-id',
  resourceId = 'mhp-filter-resource-id',
  mhpAuditData = 'mhp-audit-data',
  testResultName = 'mhp-test-result-name',
  loincCodes = 'mhp-filter-loinc-codes',
  panelName = 'mhp-filter-panel-name'
}

export declare class DFDRequestHeaders {
  [DFDHeaders.apiKey]: string;
  [DFDHeaders.authorization]?: string;
  [DFDHeaders.cacheControl]?: string;
  [DFDHeaders.clinicalEventId]?: string;
  [DFDHeaders.consumerId]?: string;
  [DFDHeaders.contentId]?: string;
  [DFDHeaders.dfdEventId]?: string;
  [DFDHeaders.eventIds]?: string;
  [DFDHeaders.encounterId]?: string;
  [DFDHeaders.mobileDeviceId]?: string;
  [DFDHeaders.patientId]?: string;
  [DFDHeaders.requestId]?: string;
  [DFDHeaders.webClientId]?: string;
}
